import React, { useEffect, useState } from 'react';
import { Indicators } from 'components/common/indicators';
import { authWords } from 'helpers/data';
import { Titlesubtitle } from 'components/common/titlesubtitle/titlesubtitle';
import { Platformbutton } from 'components/common/button/button';
import DividedPinInput from 'components/common/DividedPinInput';
import { AlertError } from 'components/common/alertboxes/alertboxes';

export const Registerleft = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const authInterval = setInterval(() => {
      setActive(prevState => (prevState === 3 ? 0 : prevState + 1));
    }, 10000);
    return () => {
      clearInterval(authInterval);
    };
  }, []);
  return (
    <section
      className="hidden lg:flex w-full relative"
      style={{ height: '100vh' }}
    >
      <div className="w-full overflow-hidden" style={{ height: '100vh' }}>
        <img
          style={{ height: '100vh' }}
          src={authWords[active].image}
          className=" max-w-[1000px]"
          alt="register"
        />
      </div>

      <div className="absolute bottom-[50px] left-0 right-0 mx-auto w-[350px] flex flex-col gap-[30px] items-center">
        <span className="flex flex-col items-center text-center text-white my-0 gap-[20px]">
          <p className="text-[1.4rem] font-[500] text-white  my-0">
            {authWords[active].title}
          </p>
          <p className="text-[1.25rem] leading-7 font-[200] text-white my-0">
            {authWords[active].subtitle}
          </p>
        </span>

        <Indicators data={[0, 1, 2, 3]} active={active} click={setActive} />
      </div>
    </section>
  );
};

export const VerifyReg = props => {
  const [pin, setPin] = useState('');

  useEffect(() => {
    props.inner && props.id && props.resend();
    // eslint-disable-next-line
  }, [props.id]);
  return (
    <div
      className={`w-full  ${!props.inner &&
        'md:w-[500px]'} flex flex-col flex-start`}
    >
      <Titlesubtitle
        title="Verify Email"
        subtitle={`Enter the Five (5) digits code we sent to ${props.title}`}
      />
      <div
        className="w-full flex flex-col gap-[5px] text-vesti-900 font-[700] text-[1rem] mb-4"
        style={{ width: '100%' }}
      >
        <p>Enter Five(5) digits code </p>
        <DividedPinInput onChange={setPin} len={6} open={props.open} />
      </div>
      <div className="w-full flex flex-col gap-[10px] items-center">
        {props.authErr && <AlertError body={props.authErr} />}
        <div className="w-full flex flex-col gap-[5px] items-center">
          <Platformbutton
            name={props.btn ? props.btn : 'Verify Account'}
            type="normal"
            click={() => props.verify(pin)}
            disabled={props.loading || pin.length < 6 ? true : false}
          />
          <Platformbutton
            type="link"
            text="Didn't get the link ? "
            title="Resend"
            click={() => props.resend()}
          />
        </div>
      </div>
    </div>
  );
};

export const Passwordcheck = props => {
  return (
    <p
      className={`${
        props.check
          ? 'text-white bg-vesti-800'
          : 'bg-grey-200 border-dashed border-1 border-grey-500 text-grey-700'
      } w-fit rounded-[30px] text-[.8em] font-[500]  my-0 py-[8px] px-[10px]`}
    >
      {props.name}
    </p>
  );
};
